import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=253aaef2&scoped=true&"
import script from "./Results.vue?vue&type=script&lang=js&"
export * from "./Results.vue?vue&type=script&lang=js&"
import style0 from "./Results.vue?vue&type=style&index=0&id=253aaef2&lang=scss&scoped=true&"
import style1 from "./Results.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253aaef2",
  null
  
)

export default component.exports